/* 
 * To change this template, choose Tools | Templates
 * and open the template in the editor.
 */
if(!window.GS) GS={};
if(!window.GS.Toolbar) GS.Toolbar={};
GS.Toolbar.Checkbox=new Class({
    Extends: GS.BaseClass,
    class_name:'GS.Toolbar.Checkbox',
    options:{
        'wrapper': null,
        'class':'submenu',
        'property':'unknow',
        'toolbar':null,
        'checked':0,
        'disabled':false
    },
    linkedTo:null,
    toolbar:null,
    'ele':null,
    'slider':{ 
        'value': 0,
        'grabber': 0 ,                                                          //this.options.grabber_width*.5,
        'dg':0
    },
    initialize:function(ele,conf){
        this.parent(conf);
        this.configure(ele);
    }
});

/**
 * 
 * @param {type} ele
 * @returns {undefined}
 */
GS.Toolbar.Checkbox.prototype.configure=function(ele){
    //console.warn('Configure checkbox...',ele);
    var self=this;
    var checked=this.options.checked;
    var disabled=this.options.disabled;
    var cls='custom-checkbox'+((checked) ? ' checked' : '');
    var c=new Element('div',{'class':cls});
    this.addEvent('set',function(e){
       checked=e; 
       checked ? c.addClass('checked') : c.removeClass('checked');
    });
    c.addEvent('click',function(e){
       e.stop();
       if(disabled) return;
       checked=!checked;
       checked ? this.addClass('checked') : this.removeClass('checked');
       self.fireEvent('change',checked);
    });
    c.inject(ele,'top');
};

